import angular from 'angular';
import * as Clipboard from 'clipboard';

import { testClipboardSupport } from '@mode/shared/util-js';

interface ClipboardScope extends angular.IScope {
  // callback that returns the detected clipboard features
  clipboardDetect: (args: { $upgraded: boolean; $legacy: boolean }) => void;
  clipboardText: string;
  clipboardEnabled: boolean;
  clipboardUpgraded: boolean;
  clipboardSuccess: () => void;
  clipboardFailed: () => void;
}

/**
 * @deprecated Prefer the `ClipboardCompatComponent` (AngularJS) or the `ClipboardDirective` (Angular)
 */
export const CopyToClipboardDirective: any = function ($window: angular.IWindowService) {
  return {
    require: '?ngModel',
    scope: {
      clipboardText: '<',
      clipboardEnabled: '=?',
      clipboardDetect: '&',
      clipboardSuccess: '&',
      clipboardFailed: '&',
    },
    link: function (scope: ClipboardScope, elem: angular.IAugmentedJQuery) {
      const hasClipboardApi = testClipboardSupport($window);
      const hasLegacyApi = Clipboard.isSupported();

      scope.clipboardEnabled = hasClipboardApi || hasLegacyApi;
      scope.$evalAsync(() => {
        scope.clipboardDetect({
          $upgraded: hasClipboardApi,
          $legacy: hasLegacyApi,
        });
      });

      if (hasClipboardApi) {
        // Attach to parent so it is possible for the component to use .stopPropagation
        // to prevent this from firing.
        elem.parent().on('click', (event) => {
          // Since the event is attached to the parent,
          // detect if the click target is inside the intended element.
          let node: Element | null = event.target;
          while (node != null) {
            if (node === (elem as any)[0]) {
              if (scope.clipboardText != null) {
                $window.navigator.clipboard
                  .writeText(scope.clipboardText)
                  .then(() => scope.$evalAsync(() => scope.clipboardSuccess()))
                  .catch(() => scope.$evalAsync(() => scope.clipboardFailed()));
              }
              break;
            }
            node = node.parentElement;
          }
        });
      } else if (hasLegacyApi) {
        const clipboard = new Clipboard((elem as any)[0], {
          text: function () {
            return scope.clipboardText;
          },
        });

        clipboard.on('success', (ev) => {
          scope.$evalAsync(() => scope.clipboardSuccess());
        });

        clipboard.on('error', () => {
          scope.$evalAsync(() => scope.clipboardFailed());
        });

        scope.$on('$destroy', () => {
          clipboard.destroy();
        });
      }
    },
  };
};

CopyToClipboardDirective.$inject = ['$window'];
